import React from 'react';
import { toast } from 'react-toastify';
import { Button, } from 'reactstrap';
import { useToggle } from 'react-use';

import firebase from '../firebase';

const db = firebase.firestore();

export default function DeleteButton ({ label = '削除', item, itemRef, beforeDelete = _ => true, onFinish, disabled, withBatch = _ => _, ...extraProps }) {
  const [isDeleting, toggleDeleting] = useToggle(false);
  const onClickDelete = async (props) => {
    if (!window.confirm('本当に削除しますか？')) return;

    toggleDeleting(true);
    try {
      if((await beforeDelete(item)) === false) return toggleDeleting(false);

      const batch = db.batch();
      batch.delete(itemRef);
      await withBatch(batch);
      await batch.commit();
      toast.success('削除しました');
      onFinish && await onFinish();
    } catch(e) {
      toast.error('失敗しました');
      throw e;
    }
    toggleDeleting(false);
  }

  return (
    <Button color="danger" onClick={onClickDelete} disabled={disabled || isDeleting} {...extraProps}>
      <span className="fas fa-trash mr-1" />
      {label}
    </Button>
  );
};
